import React from "react";
import { useDispatch } from "react-redux";
import { setPopupComponent } from "../../store/slices/ui";
import classNames from "classnames";

function AboutResults({ show }) {
  const dispatch = useDispatch();
  return (
    <div
      id="popup-about-result"
      className={classNames("popup-container", { "show-popup": show })}
    >
      <div className="popup-content">
        <a
          onClick={() => dispatch(setPopupComponent(null))}
          href="#"
          className="close"
        >
          &times;
        </a>
        <h3>About My Results</h3>
        <div class="content-scroll-popup">
          <p>A few things to consider when reviewing your results:</p>

          <ul class="about-result-list">
            <li>
              These are <i>your</i> personal feelings
              <ol>
                <li>They can’t be compared to anyone else</li>
                <li>There are no right or wrong answers</li>
              </ol>
            </li>
            <li>
              Think about your <i>whole person</i> and how each feeling relates
              to the others
              <ol>
                <li>
                  For example, how does my stress score relate to my fatigue or
                  irritability scores?
                </li>
                <li>
                  Use this survey often to track how your feelings change over
                  time
                </li>
              </ol>
            </li>

            <li>
              Think about <i>what’s worked</i> before to cope with these
              feelings
              <ol>
                <li>Check the TIPS to get some additional ideas</li>
              </ol>
            </li>
            <li>
              Don’t hesitate to seek help from your doctor, friends, family, and
              community resources
              <ol>
                <li>Check the TOOLS to find additional supports</li>
              </ol>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
}

export default AboutResults;
